(function () {
  function isInViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh && r.bottom > 0;
  }

  function init() {
    var elements = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
    if (!elements.length) return;

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    // Reveal anything already in viewport on init synchronously, so there's no
    // flash of invisible content for above-the-fold sections.
    elements.forEach(function (el) {
      if (isInViewport(el)) el.classList.add('is-revealed');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    elements.forEach(function (el) {
      if (!el.classList.contains('is-revealed')) io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
